module.exports = __webpack_public_path__ + "static/media/location-new.73c593a9.svg";